import styled, { css } from 'styled-components';

import CloseIcon from '../../icons/Close';

export const CenteredSpaceWrap = styled.div`
  ${props => props.theme.dF};
  ${props => props.theme.alignItemsCenter};
  ${props => props.theme.justifyAround};
`;

export const CenteredDivWrap = styled.div(
  props => `
    display:flex;
    align-items:center;
    justify-content:center;
    `
);

export const SmallSectionHeader = styled.h4(
  props => `
    font-weight: 500;
    font-size: ${props.theme.font.large};
    `
);

export const FlexItem = styled.div`
  display: flex;
`;

export const ButtonBase = styled.button(
  props => `
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border:none;
    background-color: ${props.bgColor || props.theme.colors.goBrand.orange};
    color: ${props.theme.colors.goWhite.base};
    font-weight: 500;
    border-radius: ${props.theme.misc.borderRadius.xxxlarge};
    font-size:${props.theme.font.custom(16)};
    &:focus{
      box-shadow: none;
      outline-offset: 0;
      outline: 0;
    }
  `
);

export const InsuranceButton = styled(ButtonBase)`
  && {
    border-radius: 0.5rem;
    padding: 1rem 1rem;
    width: 45%;
  }
`;

export const InsuranceSelectButton = styled(InsuranceButton)`
  && {
    margin-right: 1.5rem;
    border: ${props =>
      `1px solid ${
        (props.isSelected ? props.border_clr_Selected : props.border_clr) || '#2a76e3'
      }`};
    background-color: ${props =>
      props.isSelected ? props.bg_clr_selected || '#2a76e3' : props.bg_clr || '#ffffff'};
    color: ${props =>
      props.isSelected ? props.color_selected || '#ffffff' : props.color || '#2a76e3'};
    font-weight: 500;
  }
`;

export const InsuranceUnselectButton = styled(InsuranceButton)`
  && {
    background-color: ${props =>
      props.isSelected ? props.bg_clr_selected || '#dadbdc' : props.bg_clr || '#e6e6e6'};
    color: ${props => (props.isSelected ? props.color_selected : props.color) || '#717171'};
    font-weight: 500;
  }
`;

export const ModalWindow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  background-color: rgba(38, 38, 38, 0.65);
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 999;
  visibility: hidden;
  opacity: 0;
  pointer-events: none;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  padding: ${props => (props.noResult || props.mobileFeedBack ? '0rem' : '2rem')};

  &.modalVisible {
    visibility: visible;
    opacity: 1;
    pointer-events: auto;
  }
`;

export const Modal = styled.div`
  width: ${props => (props.mobileFeedBack ? '100%' : '90%')};
  position: absolute;
  bottom: ${props => (props.mobileFeedBack ? '0' : 'unset')};
  /* top: 50%;
  left: 50%; */
  /* -webkit-transform: translate(-50%, -50%); */
  /* transform: translate(-50%, -50%); */
  padding: ${props => (props.noResult ? '0rem' : '2rem')};
  background: #ffffff;
  border-radius: ${props => (props.noResult ? '20px' : '5px')};
  ${props =>
    props.insuranceModal &&
    css`
      width: 1000px;
    `}
  ${props =>
    props.BaggageModal &&
    css`
      padding: 0;
      border-radius: 5px;
    `}
      ${props =>
    props.mediumSmall &&
    css`
      max-width: 480px;
      min-width: 300px;
      max-height: 500px;
      overflow: auto;
    `}
    ${props =>
    props.loader &&
    css`
      max-width: 400px;
      min-width: 200px;
      padding: 55px 25px;
    `}
    ${props =>
    props.large &&
    css`
      max-width: 648px;
    `}
    ${props =>
    props.feedback &&
    css`
      padding: 4rem;
    `}
    ${props =>
    props.mobileFeedBack &&
    css`
      border-top-left-radius: 20px;
      border-bottom-left-radius: 0px;
      border-top-right-radius: 20px;
      border-bottom-right-radius: 0px;
    `}
    @media (min-width: 320px) and (max-width: 767px) {
    padding: 35px 20px 20px;
    line-height: 1.6;
  }
`;

export const Tip = styled.div`
  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.3);
  transition: all 0.25s ease-out;
  display: block;
  margin-bottom: 15px;
  opacity: 0;
  padding: 10px;
  pointer-events: none;
  position: absolute;
  min-width: 250px;
  border-radius: 3px;
  z-index: 99;

  line-height: 1;
  line-height: 1.2 !important;

  ${props =>
    props.TipRight &&
    css`
      right: 110%;
      top: 10px;
      transform: translate(-10px, -50%);
      &:before,
      &:after {
        content: ' ';
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        border-top: solid transparent 10px;
        border-bottom: solid transparent 10px;
        right: -10px;
        margin-right: 0;
      }
      &:before {
        border-left: 10px solid rgba(0, 0, 0, 0.2);
        right: -11px;
      }
      &:after {
        border-left: solid #fff 10px;
        z-index: 1;
      }
    `}
  ${props =>
    props.TipTop &&
    css`
      transform: translate(-45%, 5px);
      top: 110%;
      left: 50%;
      &:before,
      &:after {
        content: ' ';
        position: absolute;
        bottom: 100%;
        left: 50%;
        margin-left: -10px;
        border-left: solid transparent 10px;
        border-right: solid transparent 10px;
        transform: translateX(-50%);
      }
      &:before {
        border-bottom: 10px solid rgba(0, 0, 0, 0.2);
        margin-bottom: 1px;
      }
      :after {
        z-index: 1;
        border-bottom: solid #fff 10px;
      }
    `}

    ${props =>
    props.TipBot &&
    css`
      bottom: 100%;
      left: 50%;
      transform: translate(-50%, 10px);
      &:before,
      &:after {
        content: ' ';
        position: absolute;
        border-left: solid transparent 10px;
        border-right: solid transparent 10px;
        margin-left: -10px;
        top: 100%;
        left: 50%;
        transform: translateX(-50%);
      }
      &:before {
        border-top: 10px solid rgba(0, 0, 0, 0.2);
        margin-top: 1px;
      }
      :after {
        border-top: 10px solid #ffffff;
        z-index: 1;
      }
    `}
    ${props =>
    props.Ins &&
    css`
      min-width: 427px;
      box-shadow: 0 10px 25px 0 rgba(0, 0, 0, 0.3);
      border-radius: 8px;
      padding: 20px 10px;
      border: 2px solid #ff1515;
      left: 47%;
      opacity: 1;
      bottom: 135%;
      &:before,
      &:after {
        left: 20%;
      }
      &:before {
        border-top: 10px solid #ff1515;
        margin-top: 2px;
      }
    `}
    .ExtTipTop {
    &:before,
    &:after {
      content: ' ';
      position: absolute;
      border-left: solid transparent 10px;
      border-right: solid transparent 10px;
      margin-left: -10px;
      top: 100%;
      left: 78%;
      transform: translateX(-50%);
    }
    &:before {
      border-top: 10px solid #ff1515;
      margin-top: 2px;
    }
    :after {
      border-top: 10px solid #ffffff;
      z-index: 1;
    }
  }

  ${props =>
    props.White &&
    css`
      background-color: #ffffff;
      color: #666;
    `}
`;

export const Tooltip = styled.div`
  position: relative;
  cursor: pointer;
  &:hover ${Tip} {
    opacity: 1;
    pointer-events: auto;
    transform: translate(0, -50%);
  }
  &:hover .tiptop {
    opacity: 1;
    pointer-events: auto;
    transform: translate(-45%, 10px);
  }
  &:hover .tipbot {
    opacity: 1;
    pointer-events: auto;
    transform: translate(-50%, 5px);
  }
`;

export const FltBtn = styled.button`
  display: ${props => props.display || 'flex'};
  justify-content: center;
  border-radius: 5px;
  padding: 7px 10px;
  background-color: ${props =>
    props.btnBgColor ||
    (props.thankBtn || props.mobibleThankBtn || props.mobilePlayStoreBtn ? '#2276E3' : '#f37638')};
  border: ${props => `solid 1px ${props.btnBrColor || '#f37638'}`};
  border-width: ${props =>
    props.thankBtn || props.mobibleThankBtn || props.mobilePlayStoreBtn ? '0px' : '1px'};
  font-size: 14px;
  -webkit-appearance: none;
  && {
    color: ${props => props.btnTextColor || '#fff'};
  }
  text-align: center;
  cursor: pointer;
  outline: none;
  &.widthF105 {
    width: 105px;
  }
  position: relative;
  ${props =>
    props.next &&
    css`
      width: 120px;
      font-size: 16px;
      padding: 12px;
      background: #ff6d38;
      border-radius: 8px;
    `}
  ${props =>
    props.apply &&
    css`
      background-color: #2276e3;
      border-radius: 8px;
      padding: 7px 15px;
      margin-left: 5px;
      border: none;
    `}
    ${props =>
    props.thankBtn &&
    css`
      font-size: 16px;
      width: 300px;
      margin: 0 auto;
      padding: 12px 20px;
      margin-top: 32px;
    `}
    ${props =>
    props.mobibleThankBtn &&
    css`
      font-size: 16px;
      flex: 1;
      padding: 12px 10px;
    `}
    ${props =>
    props.mobilePlayStoreBtn &&
    css`
      font-size: 16px;
      margin-top: 30px;
      padding: 12px 10px;
    `}
    ${props => {
    if (Array.isArray(props.bgColor)) {
      return css`
        background: ${props.bgColor.length === 1
          ? props.bgColor[0]
          : `linear-gradient(90deg, ${props.bgColor.join(',')})`};
      `;
    }
  }}
`;

export const CloseIconRight = styled(CloseIcon)`
  position: absolute;
  right: 10px;
  /* top: 10px; */
  cursor: pointer;
`;

export const Button = styled.button`
  outline: none;
  border-radius: ${props => (props.radius ? props.radius : '5px')};
  padding: 1rem;
  width: ${props => props.width};
  height: ${props => (props.height ? props.height : 'auto')};
  font-size: ${props => (props.fontSize ? props.fontSize : '14px')};
  background-color: ${props => (props.bgColor ? props.bgColor : '#ffffff')};
  border: ${props => (props.borderColor ? `1px solid ${props.borderColor}` : 'none')};
  color: ${props => (props.color ? props.color : '#2276E3')};
  font-weight: ${props => (props.fontWeight ? props.fontWeight : '500')};
  cursor: pointer;
`;
